// extracted by mini-css-extract-plugin
export var bottom = "footer-module--bottom--d9ca3";
export var buttons = "footer-module--buttons--fb185";
export var footer = "footer-module--footer--bdf86";
export var region = "footer-module--region--5df41";
export var regionItem = "footer-module--regionItem--150f0";
export var region__active = "footer-module--region__active--b74a7";
export var spin = "footer-module--spin--bb16f";
export var subscribe = "footer-module--subscribe--d8b56";